import { defineStore } from 'pinia'

import type { LessonCreateStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'
import { createLessonCreateState } from './state'

export const useLessonCreateStore = defineStore('lesson-create', {
  state: (): LessonCreateStore => createLessonCreateState(),
  actions,
  getters,
})
